export default "__VITE_ASSET__DHnJTYMn__"